import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../Filters/Filters.scss';

const DateFilter = ({
  label,
  name = '',
  selected,
  onChange,
  placeholderText = 'Select date',
  onBlur
}) => {
  return (
    <div className="filter-control">
      {label && <label className="filter-label">{label}</label>}
      <DatePicker
        selected={selected}
        onChange={(date) => onChange && onChange(date)}
        onBlur={onBlur}
        name={name}
        className="filter-input"
        dateFormat="MMM dd, yyyy"    
        placeholderText={placeholderText}
      />
    </div>
  );
};

export default DateFilter;

